//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngUserProfileBasic', srsngUserProfileBasic);

    function srsngUserProfileBasic($rootScope, Localization, userSettingsService, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/user-profile-basic/user-profile-basic.html',
            scope: {
                errorCallback: '='
            },
            controller: controller
        };

        function controller($scope, authenticationService, timezonesService, POLICY_VERSION) {

            var initialData;

            $scope.model = {
                timezone: '',
                language: '',
                image: '',
                emailGAMA: '',
                phoneGAMA: '',
                ftInformation: {
                    email: false,
                    sms: false
                },
                rswdInformation: {
                    email: true,
                    sms: false
                }
            };

            $scope.languages = Localization.languages;
            $scope.timezones = '';
            $scope.commitmentToDataPrivacyAccepted = false;
            $scope.policyVersion = POLICY_VERSION;

            $rootScope.$on('localizationService:supportedLanguagesChanged', updateLanguages);
            function updateLanguages() {
                $scope.languages = Localization.languages;
            }

            $scope.cancel = cancel;
            $scope.save = save;


            initUserData();
            $rootScope.$on(Event.USER_LOGGED_IN, initUserData);

            function initUserData() {
                initialData = angular.copy($scope.model);

                getTimezones();
                initUserLanguage();
                initUserTimezone();
                initCommitmentToDataPrivacyInfo();

                if (authenticationService.profile) {

                    $scope.model.emailGAMA = authenticationService.profile.email;
                    initialData.emailGAMA = authenticationService.profile.email;

                    $scope.model.phoneGAMA = authenticationService.profile.attributes.mobilePhone ? authenticationService.profile.attributes.mobilePhone.toString() : '';
                    initialData.phoneGAMA = authenticationService.profile.attributes.mobilePhone ? authenticationService.profile.attributes.mobilePhone.toString() : '';

                } else {
                    $scope.model.emailGAMA = '';
                    initialData.emailGAMA = '';
                    $scope.model.phoneGAMA = '';
                    initialData.phoneGAMA = '';
                }

            }

            function initUserLanguage() {
                let updatePromise = userSettingsService.loadUserSetting('container', 'language')
                    .then(language => {
                        initialData.language = language ? language.language : '';
                        $scope.model.language = language ? language.language : '';
                    }, () => {
                        console.log('userSetting language is not set');
                    });
                $rootScope.$emit('handleBusyPromise', updatePromise);
            }

            function getTimezones() {
                $scope.timezones = timezonesService.getTimezonesList();
            }

            function initUserTimezone() {
                let updatePromise = userSettingsService.loadUserSetting('container', 'timezone')
                    .then(timezone => {
                        initialData.timezone = timezone ? timezone.value : '';
                        $scope.model.timezone = timezone ? timezone.value : '';
                    }, () => {
                        console.log('userSetting timezone is not set');
                    });
                $rootScope.$emit('handleBusyPromise', updatePromise);
            }

            function initCommitmentToDataPrivacyInfo() {
                let updatePromise = userSettingsService.loadUserSetting('container', 'commitmentToDataPrivacy')
                    .then(commitmentToDataPrivacy => {
                        $scope.commitmentToDataPrivacyAccepted = false;
                        if (commitmentToDataPrivacy && commitmentToDataPrivacy.agreements) {
                            $scope.commitmentToDataPrivacyAccepted = commitmentToDataPrivacy.agreements.find(agr => agr.version === $scope.policyVersion).accepted;
                        }
                    }, () => {
                        $scope.commitmentToDataPrivacyAccepted = false;
                    });
                $rootScope.$emit('handleBusyPromise', updatePromise);
            }

            let removeCancelListener = $rootScope.$on('userProfile:cancel', cancel);
            let removeSaveListener = $rootScope.$on('userProfile:save', save);

            function cancel() {
                $scope.model = angular.copy(initialData);
            }

            function save() {
                Localization.changeLanguage($scope.languages.find(elem => elem.language === $scope.model.language));
                Localization.changeTimezone($scope.timezones.find(elem => elem.value === $scope.model.timezone));


                userSettingsService.saveUserProfile('container', 'ftInfoNotificationMethods', $scope.model.ftInformation != null ? $scope.model.ftInformation : { email: false, sms: false });
                userSettingsService.saveUserProfile('container', 'rswdInfoNotificationMethods', $scope.model.rswdInformation != null ? $scope.model.rswdInformation : { email: false, sms: false });


                initialData = angular.copy($scope.model);
            }

            $scope.$on('$destroy', function () {
                removeCancelListener();
                removeSaveListener();
            });
        }
    }
}) ();

